import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import SearchField from '../SearchField';
import ContainerScrollable from '../ContainerScrollable';
import { StyledChip } from '../Chip';

const Container = styled.div`
  padding: 8px;
`;

const SearchResult = styled.span`
  font-weight: bold;
`;

const Search = styled.div`
  @media (min-width: 1024px) {
    display: flex;
    align-content: center;
    justify-content: center;
  }
`;

const StyledSearchField = styled(SearchField)`
  width: 100%;
  margin-bottom: 5px;
  color: ${({ theme }) => theme.palette.primary.main};

  label {
    font-family: ${({ theme }) => theme.fonts.primary};
  }

  @media (min-width: 1024px) {
    width: 80%;
    margin-bottom: 0;
  }

  max-width: 1024px;
`;

const galleryPropertyTypes = {
  children: PropTypes.node,
  tags: PropTypes.arrayOf(
    PropTypes.string,
  ),
  searchIsEmpty: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  search: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  getUpdateSearch: PropTypes.func,
  internalUseFilter: PropTypes.node,
};

type GalleryProperties = InferProps<typeof galleryPropertyTypes>;

const Gallery = ({
  children,
  tags,
  search,
  onSearch,
  loading,
  label,
  onClear,
  searchIsEmpty,
  getUpdateSearch,
  internalUseFilter,
}: GalleryProperties) => (
  <>
    <Container>
      <Search>
        <StyledSearchField
          id="lookbook-search"
          label={loading ? 'Searching' : label}
          value={search ?? undefined}
          onChange={onSearch}
          onClear={onClear}
          name="search"
        />
      </Search>
      {
        tags && (
          <ContainerScrollable>
            {tags.map((filter) => (
              <StyledChip
                key={filter}
                onClick={getUpdateSearch?.(filter)}
                label={filter}
              />
            ))}
          </ContainerScrollable>
        )
      }
      {!loading && searchIsEmpty ? (
        <p>
          {
            search ? (
              <>
                {'No results found for: '}
                <SearchResult>{search}</SearchResult>
              </>
            ) : 'No results found'
          }
        </p>
      ) : undefined}
      {internalUseFilter}
    </Container>
    {children}
  </>
);

Gallery.propTypes = galleryPropertyTypes;

export default Gallery;
